import React from "react";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import Loader from "components/Loader";

// Material Dashboard 2 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// local
import ScheduleContainer from "./ScheduleContainer";
import Filters from "./Filters";

// redux
import { useSelector, useDispatch } from "react-redux";
import * as actions from "redux/actions/schedule";
import * as actionTypes from "redux/constants";

const Schedule = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const schedule = useSelector((state) => state.schedule);
  const auth = useSelector((state) => state.auth);

  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [schedule.pagination.page]);

  React.useEffect(() => {
    dispatch(actions.getSchedules(schedule.pagination.page, schedule.pagination.pageSize));

    return () => {
      dispatch(actions.resetSchedulePagination());
    };
  }, [dispatch]);

  const handlePagination = (page) => {
    dispatch(actions.getSchedules(page, schedule.pagination.pageSize));
  };

  const handleDelete = (id) => {
    const payload = { id };
    dispatch(actions.deleteSchedule(payload));
  };

  const handleEdit = (id) => {
    const scheduleData = schedule.schedules.find((s) => s.id === id);
    if (scheduleData) navigate(`/upload/schedule/add-schedule`, { state: { editData: scheduleData } });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Grid container>
        {schedule.loading ? (
          <Loader />
        ) : (
          <>
            {actionTypes.ADVANCED_SECTION.includes(auth.user?.role) && (
              <Grid item xs={12} md={12} xl={12}>
                <MDBox py={3} pl={1}>
                  <Filters />
                </MDBox>
              </Grid>
            )}
            <Grid item xs={12} md={12} xl={12}>
              <MDBox py={3} pr={1}>
                <ScheduleContainer
                  schedules={schedule.schedules}
                  pagination={schedule.pagination}
                  handlePagination={handlePagination}
                  handleDelete={handleDelete}
                  handleEdit={handleEdit}
                />
              </MDBox>
            </Grid>
          </>
        )}
      </Grid>
    </DashboardLayout>
  );
};

export default Schedule;
